module.exports = __webpack_public_path__ + "static/media/goteborgsstad.a0bb9709.png";